module.exports = __webpack_public_path__ + "img/truckHead-blue.a8e20651.svg";